import type { ReactNode } from 'react';

/** A single centred column, for the screens before the console. */
export function Centered({ children }: { children: ReactNode }) {
  return <main className="center"><div className="center__stack">{children}</div></main>;
}
